export const FETCH_ALL = 'spaces/FETCH_ALL';
export const FETCH_ALL_SUCCESS = 'spaces/FETCH_ALL_SUCCESS';
export const FETCH_ALL_ERROR = 'spaces/FETCH_ALL_ERROR';

export const FETCH_ALL_FOR_ALL_FOLDER_TREES = 'spaces/FETCH_ALL_FOR_ALL_FOLDER_TREES';
export const FETCH_ALL_FOR_ALL_FOLDER_TREES_SUCCESS = 'spaces/FETCH_ALL_FOR_ALL_FOLDER_TREES_SUCCESS';
export const FETCH_ALL_FOR_ALL_FOLDER_TREES_ERROR = 'spaces/FETCH_ALL_FOR_ALL_FOLDER_TREES_ERROR';

export const CREATE = 'spaces/CREATE';
export const CREATE_SUCCESS = 'spaces/CREATE_SUCCESS';
export const CREATE_ERROR = 'spaces/CREATE_ERROR';

export const UPDATE = 'spaces/UPDATE';
export const UPDATE_BODY = 'spaces/UPDATE_BODY';
export const UPDATE_SUCCESS = 'spaces/UPDATE_SUCCESS';
export const UPDATE_ERROR = 'spaces/UPDATE_ERROR';

export const DELETE = 'spaces/DELETE';
export const DELETE_SUCCESS = 'spaces/DELETE_SUCCESS';
export const DELETE_ERROR = 'spaces/DELETE_ERROR';

export const SET_ACTIVE_SPACE_ID = 'spaces/SET_ACTIVE_SPACE_ID';
